import { render, staticRenderFns } from "./StateAddress.vue?vue&type=template&id=2ddae34f"
import script from "./StateAddress.vue?vue&type=script&lang=js"
export * from "./StateAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports